<template>
  <div v-title :data-title="$route.name">
    <!-- style=" border-style: solid; border-width: 5px; border-color: transparent;" -->
    <div
      v-if="offsetwidth > 850"
      style="
        width: 100%;
        overflow: hidden;
        position: relative;
        min-width: 1349px;
        margin-top: 65px;
        background-color: #fff;
      "
    >
      <div style="position: relative">
        <img
          style="width: 100%"
          src="../assets/Battertimg/PC/productBanner.jpg"
          alt=""
        />
        <div
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            color: white;
            text-align: left;
            z-index: 10;
          "
        >
          <div
            style="
              font-size: 53px;
              font-family: Cotyledon-Regular-bold;
              line-height: 1;
              margin-bottom: 8px;
            "
          >
            Products
          </div>
        </div>
      </div>
      <!-- content -->
      <div style="background-color: #fff" class="flex flex_around">
        <div class="flex" style="width: 1200px">
          <div>
            <div
              class="text_left"
              style="
                font-size: 18px;
                font-family: Cotyledon-Regular-bold;
                margin-top: 40px;
                margin-bottom: 30px;
              "
            >
              <div>
                <span class="pointer fonthover" @click="Goback()">Product </span
                >>
                <span class="pointer fonthover" @click="Goback()">{{
                  information.ProductTypeName
                }}</span>
                > {{ information.ProductName }}
              </div>
            </div>
            <!-- 轮播图 -->
            <div style="width: 470px; margin-bottom: 50px; position: relative">
              <!-- 视口 -->

              <div
                style="
                  width: 470px;
                  height: 466px;
                  border: 2px solid #eee;
                  overflow: hidden;
                "
              >
                <div
                  ref="ViewImg"
                  style="
                    position: relative;
                    width: 470px;
                    height: 466px;
                    transition: transform 0.5s ease;
                    z-index: 3;
                  "
                  :style="wrapperStyle"
                >
                  <div class="flex flex_around" style="position: absolute">
                    <div
                      style="width: 470px; flex: 1; align-items: center"
                      v-for="(item, index) in carousel"
                      :key="index"
                    >
                      <div
                        style="
                          position: relative;
                          width: 470px;
                          top: -4px;
                          z-index: 4;
                        "
                      >
                        <img
                          v-if="
                            item.ISImage &&
                            (item.FileFormat != '' || item.FileFormat != null)
                          "
                          style="max-height: 466px; max-width: 466px"
                          :src="item.FilePath"
                          alt=""
                        />
                        <video
                          :poster="item.generatedPoster"
                          muted
                          preload="metadata"
                          controls
                          @loadeddata="onVideoLoaded(index)"
                          @click="toggleFullscreen(index)"
                          @ended="
                            () => {
                              playing = false;
                            }
                          "
                          v-else
                          style="max-height: 466px; max-width: 466px"
                          class="media-content"
                          ref="videoPlayer"
                        >
                          <source :src="getVideoSrc(index)" type="video/mp4" />
                          <source :src="getVideoSrc(index)" type="video/webm" />
                          <source :src="getVideoSrc(index)" type="video/ogg" />
                        </video>
                        <img
                          @click="toggleFullscreen(index)"
                          id="playbtn"
                          class="pointer"
                          v-if="
                            !(
                              item.ISImage &&
                              (item.FileFormat != '' || item.FileFormat != null)
                            )
                          "
                          src="../assets/Battertimg/PC/play.png"
                          style="
                            width: 46px;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translateX(-50%) translateY(-50%);
                          "
                          alt=""
                        />
                        <!-- <video muted preload="metadata"-player
                  v-else
                  class="video-player vjs-custom-skin mb_5"
                  style="width: 150px; height: 180px"
                  :options="{
                    sources: [
                      {
                        src: it.FilePath,
                      },
                    ],
                    height: '180px !important',
                    controls: true,
                    playbackRates: [0.5, 1, 1.5, 2],
                  }"
                >
                </video-player> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div
                style="
                  width: 470px;
                  height: 466px;
                  border: 2px solid #ccc;
                  object-fit: fill;
                  transition: transform 0.5s ease;
                "
                  :style="wrapperStyle"

                class="flex flex_around"
              >
                <img
                  style="height: 466px; padding: 20px 0; "
                  
                  src=""
                  alt=""
                />
              </div> -->
              <div class="flex">
                <div
                  v-if="carousel.length > 3"
                  @click="GetPage('left')"
                  class="pointer"
                  style="border-top: 2px solid #eee"
                >
                  <img src="../assets/Battertimg/H5/left.jpg" alt="" />
                </div>
                <div
                  v-if="carousel.length > 0"
                  ref="centeredSwiper"
                  class="flex"
                >
                  <div
                    style="width: 130px; height: 130px"
                    v-for="(slide, index) in carouselPage"
                    :key="index"
                  >
                    <div
                      @click="ChangeShowImg(index)"
                      class="slide-content flex flex_around"
                      :style="{
                        borderLeft:
                          index === 0 && carousel.length <= 3
                            ? '2px solid #eee'
                            : '',
                      }"
                      style="
                        position: relative;
                        width: 130px;
                        height: 130px;
                        padding: 5px 0;
                        transition: transform 0.5s ease;
                      "
                    >
                      <img
                        v-if="
                          slide.ISImage &&
                          (slide.FileFormat != '' || slide.FileFormat != null)
                        "
                        style="
                          max-height: 110px;
                          max-width: 130px;
                          padding: 0 2px;
                        "
                        :src="slide.FilePath"
                        :alt="slide.FileName"
                        class="media-element"
                      />
                      <video
                        :poster="slide.generatedPoster"
                        muted
                        @loadeddata="onVideoLoaded(index)"
                        preload="metadata"
                        @click="toggleFullscreen(index)"
                        v-else
                        style="max-height: 120px; max-width: 120px"
                        class="media-content"
                      >
                        <source :src="slide.FilePath" type="video/mp4" />
                        <source :src="slide.FilePath" type="video/webm" />
                        <source :src="slide.FilePath" type="video/ogg" />
                      </video>
                      <img
                        @click="toggleFullscreen(index)"
                        class="pointer"
                        v-if="
                          !(
                            slide.ISImage &&
                            (slide.FileFormat != '' || slide.FileFormat != null)
                          )
                        "
                        src="../assets/Battertimg/PC/play.png"
                        style="
                          width: 36px;
                          position: absolute;
                          top: 50%;
                          left: 50%;
                          transform: translateX(-50%) translateY(-50%);
                        "
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <div
                  v-if="carousel.length > 3"
                  @click="GetPage('right')"
                  class="pointer"
                  style="border-top: 2px solid #eee"
                >
                  <img src="../assets/Battertimg/H5/right.jpg" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div>
            <!-- 文字描述 -->
            <div
              style="
                margin-left: 40px;
                margin-top: 100px;
                text-align: left;
                min-height: 400px;
              "
            >
              <div style="font-family: Cotyledon-Regular-bold; font-size: 18px">
                {{ information.ProductName }}
              </div>
              <div>{{ information.KeyPrarameters }}</div>
              <div class="mt_20 mb_20">
                <el-button
                  @click="LearnMore()"
                  style="font-size: 14px"
                  class="LearnBtn"
                  round
                  >Learn More</el-button
                >
              </div>
              <div
                ref="introContentPC"
                style="line-height: 32px; font-size: 14px; margin: 0"
                v-html="information.Introduction"
              ></div>
            </div>
            <div style="margin-left: 50px" class="bor_b"></div>
            <div
              style="margin-left: 50px; margin-bottom: 50px; margin-top: 20px"
              class="mt_20 text_left"
            >
              <div class="mb_20" style="font-family: Cotyledon-Regular-bold">
                Download center
              </div>
              <div
                @click="Download(item)"
                class="underline pointer"
                v-for="(item, index) in technicalManual"
                :key="index"
              >
                {{ item.FileName }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部导航 -->
      <footer class="header-navbar">
        <!-- 第一行：LOGO和导航项 -->
        <div class="top-nav" style="height: 28px !important">
          <div class="logo-container">
            <div class="logo">
              <img
                style="height: 28px !important"
                src="../assets/Battertimg/PC/Batteryplantlogo.png"
                alt=""
              />
            </div>
          </div>

          <div class="nav-items">
            <div class="nav-item" @click="goto('HOME')">HOME</div>
            <div class="nav-item" @click="goto('PROJECT')">ABOUT US</div>
            <div class="nav-item" @click="goto('PRODUCTS')">PRODUCTS</div>
            <div class="nav-item" @click="goto('CASE')">GALLERY</div>
            <div class="nav-item" @click="goto('CONTACTUS')">CONTACT US</div>
            <div class="nav-item" @click="goto('CONTACTUS')">BOOK NOW</div>
          </div>
        </div>
        <div
          style="
            height: 1px;
            background-color: #cccccc;
            margin-top: 15px;
            margin-bottom: 18px;
          "
        ></div>
        <!-- 间距30px后的邮件信息 -->
        <div>
          <div class="email-content">(04) 5245 7579</div>
          <div class="email-content">info@batteryplant.com.au</div>
          <div class="email-content">203 Blackburn Rd Mount Waverley VIC 3149</div>
        </div>
      </footer>
    </div>
    <div
      v-else
      style="
        width: 100%;
        background-color: #fff;
        overflow: hidden;
        position: relative;
      "
    >
      <div
        style="
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          overflow: hidden;
          font-size: 24px;
          padding: 12px 0;
          color: #fff;
          font-family: Cotyledon-Regular-bold;
        "
      >
        <img
          style="height: 48px"
          src="../assets/Battertimg/H5/ProductBanner.jpg"
          alt=""
        />
        <div class="pos_abs">Products</div>
      </div>
      <div style="padding: 0 10px">
        <div>
          <div
            class="text_left"
            style="
              font-size: 20px;
              font-family: Cotyledon-Regular-bold;
              margin-top: 15px;
            "
          >
            <span class="pointer" @click="Goback()">Product </span>>
            <span class="pointer" @click="Goback()">{{
              information.ProductTypeName
            }}</span>
            > {{ information.ProductName }}
          </div>
          <!-- 轮播图 -->

          <div class="flex flex_around">
            <el-carousel
              @change="StopAllVideo()"
              ref="elCarousel"
              style="width: 96%; margin-top: 40px; margin-bottom: 30px"
              trigger="click"
              :interval="300000"
              arrow="always"
              :effect="'creative'"
            >
              <el-carousel-item v-for="(item, index) in carousel" :key="index">
                <div
                  class="creative-slide flex flex_around"
                  :class="{
                    'active-slide': item === index,
                  }"
                >
                  <div
                    style="text-align: center; position: relative; width: 85.3%"
                  >
                    <!-- background-color: rgb(239, 246, 252); -->

                    <div
                      style="height: 220px; overflow: hidden"
                      class="mt_20 mb_20"
                    >
                      <div
                        class="flex flex_around"
                        style="
                          width: 100%;
                          height: 220px;
                          align-items: center;
                          position: relative;
                          text-align: center;
                          overflow: hidden;
                        "
                      >
                        <el-image
                          class="flex flex_around"
                          v-if="
                            item.ISImage &&
                            (item.FileFormat != '' || item.FileFormat != null)
                          "
                          style="
                            margin: 0 auto;
                            display: inline-block; /* 或 block */
                            max-width: 100%;
                            height: 220px; /* 固定高度，与容器一致 */
                            object-fit: contain;
                          "
                          ref="imgHeight"
                          :src="item.FilePath"
                          :alt="item.ProductName"
                          :preview-src-list="carouselList"
                        ></el-image>
                        <video
                          :poster="item.generatedPoster"
                          muted
                          @loadeddata="onVideoLoaded(index)"
                          preload="metadata"
                          @click="toggleFullscreencopy(index)"
                          @ended="
                            () => {
                              playing = false;
                            }
                          "
                          v-else
                          style="height: 220px"
                          class="media-content"
                          ref="videoPlayer"
                        >
                          <source :src="item.FilePath" type="video/mp4" />
                          <source :src="item.FilePath" type="video/webm" />
                          <source :src="item.FilePath" type="video/ogg" />
                          Your browser does not support the video tag.
                        </video>
                        <img
                          @click="toggleFullscreencopy(index)"
                          class="pointer playbtn"
                          v-if="
                            !(
                              item.ISImage &&
                              (item.FileFormat != '' || item.FileFormat != null)
                            )
                          "
                          src="../assets/Battertimg/PC/play.png"
                          style="
                            width: 45px;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translateX(-50%) translateY(-50%);
                          "
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <!-- <img
              style="width: 400px"
              src="../assets/Battertimg/H5/bgBar.png"
              alt=""
            /> -->

        <div>
          <!-- 文字描述 -->
          <div style="margin-left: 20px; text-align: left; min-height: 400px">
            <div style="font-size: 30px; font-family: Cotyledon-Regular-bold">
              {{ information.ProductName }}
            </div>
            <div style="font-size: 18px">{{ information.KeyPrarameters }}</div>
            <div class="mt_20 mb_20">
              <el-button
                style="font-size: 18px"
                @click="LearnMore()"
                class="LearnBtn"
                round
                >Learn More</el-button
              >
            </div>
            <div
              ref="introContentMobile"
              style="line-height: 32px; font-size: 18px; margin: 0"
              v-html="information.Introduction"
            ></div>
          </div>
          <div class="bor_b"></div>
          <!-- pdf下载 -->
          <div
            style="margin-bottom: 50px; margin-top: 20px"
            class="mt_20 text_left"
          >
            <div class="mb_20" style="font-family: Cotyledon-Regular-bold">
              Download center
            </div>
            <div
              @click="Download(item)"
              class="underline pointer"
              v-for="(item, index) in technicalManual"
              :key="index"
            >
              {{ item.FileName }}
            </div>
          </div>
        </div>
      </div>

      <!-- 在移动端部分（v-else内）修改底部导航栏 -->
      <footer class="mobile-footer-navbar">
        <!-- 垂直排列的容器 -->
        <div class="vertical-container">
          <!-- LOGO区域 -->
          <div class="logo-section">
            <div class="logo-container">
              <div class="logo">
                <img
                  style="height: 28px !important"
                  src="../assets/Battertimg/PC/Batteryplantlogo.png"
                  alt="Battery Plant Logo"
                />
              </div>
            </div>
          </div>

          <!-- 导航项区域（手动编写每个项） -->
          <div class="nav-section">
            <div
              class="nav-item"
              :class="{ active: activeNav === 0 }"
              @click="
                activateNav(0);
                goto('HOME');
              "
            >
              HOME
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 1 }"
              @click="
                activateNav(1);
                goto('PROJECT');
              "
            >
              ABOUT US
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 2 }"
              @click="
                activateNav(2);
                goto('PRODUCTS');
              "
            >
              PRODUCTS
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 3 }"
              @click="
                activateNav(3);
                goto('CASE');
              "
            >
              GALLERY
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 4 }"
              @click="
                activateNav(4);
                goto('CONTACTUS');
              "
            >
              CONTACT US
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 5 }"
              @click="
                activateNav(5);
                goto('CONTACTUS');
              "
            >
              BOOK NOW
            </div>
          </div>
          <div style="height: 1px; background-color: #cccccc"></div>
          <!-- 邮件信息区域 -->
          <div class="contact-section">
            <div class="email-contentmobile">(04) 5245 7579</div>
            <div class="email-contentmobile">info@batteryplant.com.au</div>
            <div class="email-contentmobile">203 Blackburn Rd Mount Waverley VIC 3149</div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { get } from "../assets/api/api";
import { ProductInformation } from "../assets/api/request";
export default {
  props: {
    offsetwidth: {
      type: Number,
    },
  },

  data() {
    return {
      activeNav: null, // 跟踪当前激活的导航项
      carousel: [],
      carouselList: [],
      carouselPage: [],
      information: {
        Introduction: "",
        KeyPrarameters: "",
        ProductName: "",
        ProductTypeId: "",
        ProductTypeName: "",
      },
      technicalManual: [],
      currentActiveIndex: 0,
      currentIndex: 0,
      SwiperPage: 0,
      wrapperStyle: { transform: `translateX(-${this.currentIndex * 470}px)` },

      playing: false,
    };
  },
  watch: {
    information: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.setupImagePreview();
        });
      },
    },
  },
  computed: {
    getVideoSrc() {
      return (index) => {
        return this.carousel[index].FilePath;
      };
    },
  },
  // computed: {
  //   // wrapperStyle() {
  //   //   return { transform: `translateX(-${this.currentIndex *470}px)` }; // 根据currentIndex移动wrapper，300px为单张图片的宽度，需与CSS中设置的一致。可以根据需要调整。
  //   // },
  //   carouselPage() {
  //     console.log(this.carousel.slice(this.SwiperPage, 3));
  //     return this.carousel.length > 0
  //       ? this.carousel.slice(this.SwiperPage, 3)
  //       : [];
  //   },
  // },
  mounted() {
    this.slideBanner("elCarousel");
    document.documentElement.scrollTop = 0;
    this.getData();
    // 等待数据加载完成后设置预览
    this.$nextTick(() => {
      this.setupImagePreview();
    });
  },

  methods: {
    Goback() {
      this.$router.go(-1);
    },

    getData() {
      get(
        ProductInformation +
          "?ToProductId=" +
          sessionStorage.getItem("ProductId")
      ).then((res) => {
        if (res.data.code === 200) {
          this.carousel = res.data.carousel;
          this.carouselList = [];
          this.carousel.forEach((item) => {
            item.loadingPoster = true;
            item.generatedPoster = "";
            item.ISImage =
              item.FileFormat && item.FileFormat.split("/")[0] === "image";
            item.ISImage ? this.carouselList.push(item.FilePath) : "";
          });
          this.carouselPage = this.carousel.slice(0, 3);
          this.information = res.data.information[0];

          this.technicalManual = res.data.technicalManual;
          this.$nextTick(() => {
            this.generateAllVideoPosters();
          });
        }
      });
    },
    async Download(item) {
      axios
        .get(item.FilePath, {
          //静态资源文件夹public
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", item.FileName);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.log("error:" + JSON.stringify(error));
        });
    },
    LearnMore() {
      this.$router.push("/ContactUs");
    },
    toggleFullscreencopy(index) {
      let video = this.$refs.videoPlayer[index];

      // const video = event.target;
      // console.log(video);

      // 播放/暂停切换
      if (!this.playing) {
        video
          .play()
          .then((res) => {
            this.playing = true;
          })
          .catch((e) => console.log("播放失败:", e));
      } else {
        video.pause();
        this.playing = false;
      }

      // 全屏请求
      if (document.fullscreenEnabled) {
        if (!document.fullscreenElement) {
          video.requestFullscreen().catch((e) => {
            console.error("全屏失败:", e);
            // 可选：回退到页面全屏
            this.$refs.videoPlayer.classList.add("fullscreen-fallback");
          });
        } else {
          document.exitFullscreen().then(video.pause());
        }
      }
    },
    toggleFullscreen(index) {
      // const video = event.target;
      // console.log(this.$refs.videoPlayer, index, this.$refs.videoPlayer[index]);

      let video = this.$refs.videoPlayer[index];
      // console.log(video);

      // 播放/暂停切换
      if (!this.playing) {
        video
          .play()
          .then((res) => {
            this.playing = true;
          })
          .catch((e) => console.log("播放失败:", e));
      } else {
        video.pause();
        this.playing = false;
      }

      // // 全屏请求
      // if (document.fullscreenEnabled) {
      //   if (!document.fullscreenElement) {
      //     video.requestFullscreen().catch((e) => {
      //       console.error("全屏失败:", e);
      //       // 可选：回退到页面全屏
      //       this.$refs.videoPlayer.classList.add("fullscreen-fallback");
      //     });
      //   } else {
      //     document.exitFullscreen();
      //   }
      // }
    },
    GetPage(type) {
      if (type === "left") {
        if (this.SwiperPage > 0) {
          this.SwiperPage -= 1;
        }
      } else if (type === "right") {
        // console.log(this.SwiperPage, this.carousel.length - 1);
        if (this.carousel.length > (this.SwiperPage + 1) * 3) {
          this.SwiperPage += 1;
        } else {
          return;
        }
      }
      // console.log(
      //   this.carousel.length,
      //   this.SwiperPage,

      // );
      this.carouselPage = this.carousel.slice(
        this.SwiperPage * 3,
        Math.min((this.SwiperPage + 1) * 3, this.carousel.length)
      );
      // this.carouselPage = this.carousel.slice(
      //   this.SwiperPage,
      //   this.SwiperPage + 3
      // );
    },
    StopAllVideo() {
      if (this.playing) {
        this.$refs.videoPlayer.forEach((item) => {
          let video = item;
          video.pause();
        });
      }
    },
    ChangeShowImg(index) {
      this.StopAllVideo();

      // this.toggleFullscreen();
      //  {
      //   transform: `translateX(-${this.currentIndex *470}px)`
      //  }

      // if (type === "left") {
      //   this.currentIndex >= 1
      //     ? (this.currentIndex -= 1)
      //     : (this.currentIndex = length);

      //   this.wrapperStyle = {
      //     transform: `translateX(-${this.currentIndex *470}px)`,
      //   };
      // } else if (type === "right") {
      //   this.currentIndex < length
      //     ? (this.currentIndex += 1)
      //     : (this.currentIndex = 0);

      //   this.wrapperStyle = {
      //     transform: `translateX(-${this.currentIndex *470}px)`,
      //   };
      // } else {
      this.currentIndex = this.SwiperPage * 3 + index;
      this.wrapperStyle = {
        transform: `translateX(-${this.currentIndex * 470}px)`,
      };
      // }
    },
    handleImageClick(index) {
      // 确保预览组件已初始化
      this.$nextTick(() => {
        // 获取预览组件实例
        const viewer = document.querySelector(".el-image-viewer");

        if (viewer) {
          // 1. 自动触发放大操作
          this.autoZoom(viewer);

          // 2. 设置初始缩放比例
          setTimeout(() => {
            const img = viewer.querySelector(".el-image-viewer__img");
            if (img) {
              img.style.transform = "scale(1.5)"; // 初始放大1.5倍
            }
          }, 50);
        }
      });
    },
    // 生成所有视频封面
    async generateAllVideoPosters() {
      const videoSlides = this.carousel.filter((carousel) => !carousel.ISImage);
      // console.log(videoSlides, "all");

      const promises = videoSlides.map((carousel, index) =>
        this.generateVideoPoster(this.carousel.indexOf(index))
      );

      await Promise.allSettled(promises);
    },

    // 生成视频封面
    generateVideoPoster(index) {
      return new Promise((resolve) => {
        this.$refs.videoPlayer[index];
        const videoElement = this.$refs.videoPlayer[index]
          ? this.$refs.videoPlayer[index]
          : null;
        // console.log(videoElement, "ref");

        if (!videoElement) {
          console.warn(`视频元素 videoPlayer 未找到`);
          resolve();
          return;
        }

        this.carousel[index].loadingPoster = true;

        const onLoadedMetadata = () => {
          try {
            videoElement.currentTime = 11;
          } catch (error) {
            console.error("设置视频时间失败:", error);
            this.carousel[index].loadingPoster = false;
            resolve();
          }
        };

        const onSeeked = () => {
          try {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.width = videoElement.videoWidth;
            canvas.height = videoElement.videoHeight;
            ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
            const posterDataURL = canvas.toDataURL("image/jpeg", 0.8);

            this.carousel[index].generatedPoster = posterDataURL;
            this.carousel[index].loadingPoster = false;

            videoElement.removeEventListener(
              "loadedmetadata",
              onLoadedMetadata
            );
            videoElement.removeEventListener("seeked", onSeeked);
            resolve();
          } catch (error) {
            console.error("生成视频封面失败:", error);
            this.carousel[index].loadingPoster = false;
            resolve();
          }
        };

        const onError = (error) => {
          console.error(`视频 ${index} 加载失败:`, error);
          this.carousel[index].loadingPoster = false;
          videoElement.removeEventListener("loadedmetadata", onLoadedMetadata);
          videoElement.removeEventListener("seeked", onSeeked);
          videoElement.removeEventListener("error", onError);
          resolve();
        };

        videoElement.addEventListener("loadedmetadata", onLoadedMetadata);
        videoElement.addEventListener("seeked", onSeeked);
        videoElement.addEventListener("error", onError);

        // 如果视频已经加载了元数据
        if (videoElement.readyState >= 1) {
          onLoadedMetadata();
        }

        // 设置超时
        setTimeout(() => {
          if (this.carousel[index].loadingPoster) {
            console.warn(`视频封面生成超时: ${index}`);
            this.carousel[index].loadingPoster = false;
            videoElement.removeEventListener(
              "loadedmetadata",
              onLoadedMetadata
            );
            videoElement.removeEventListener("seeked", onSeeked);
            videoElement.removeEventListener("error", onError);
            resolve();
          }
        }, 10000); // 10秒超时
      });
    },
    onVideoLoaded(index) {
      if (
        !this.carousel[index].ISImage &&
        !this.carousel[index].generatedPoster &&
        !this.carousel[index].loadingPoster
      ) {
        this.generateVideoPoster(index);
      }
    },
    onSlideChange() {
      if (this.swiperInstance) {
        // this.ActiveImg = item.FilePath;
        // this.ActiveImgName = item.FileName;
        this.currentActiveIndex = this.swiperInstance.activeIndex;
        // console.log('当前激活索引:', this.currentActiveIndex);
        // this.$router.push({
        //   path: "/Case",
        //   // query: {
        //   //   QRMACID: row.QRMACID,
        //   // },
        // });
        // 暂停非当前视频
        // this.pauseInactiveVideos();
      }
    },

    autoZoom(viewer) {
      // 查找放大按钮并模拟点击
      const zoomInBtn = viewer.querySelector(".el-image-viewer__zoom-in");
      if (zoomInBtn) {
        // 点击两次达到2倍放大效果（可根据需要调整次数）
        zoomInBtn.click();
        setTimeout(() => zoomInBtn.click(), 30);
      }
    },
    // 激活导航项方法
    activateNav(index) {
      this.activeNav = index;
    },
    goto(name) {
      if (name == "HOME") {
        window.sessionStorage.setItem("activeIndexh5", "/index");
        this.$router.push("/index");
      } else if (name == "PROJECT") {
        window.sessionStorage.setItem("activeIndexh5", "/Project");

        this.$router.push("/Project");
      } else if (name == "PRODUCTS") {
        window.sessionStorage.setItem("activeIndexh5", "/Productslist");
        this.$router.push("/Productslist");
      } else if (name == "CASE") {
        window.sessionStorage.setItem("activeIndexh5", "/Case");
        this.$router.push("/Case");
        // window.open('https://smartuser.com.au/customerdetails/')
        // this.$router.push("/ProjectGallery")
      } else if (name == "CONTACTUS") {
        window.sessionStorage.setItem("activeIndexh5", "/ContactUs");

        this.$router.push("/ContactUs");
      }
    },
    // goinfo() {
    //   // window.sessionStorage.setItem("activeIndex", "/CustomerDetails");
    //   this.$emit("fun", "/CustomerDetails");
    // },
    // 滑动切换
    slideBanner(name) {
      // console.log(this.$refs[name]);

      const box = document.querySelector(".el-carousel__container");
      if (!box) return;

      let startPointX = 0;
      let stopPointX = 0;

      const resetPoint = function () {
        startPointX = 0;
        stopPointX = 0;
      };

      box.addEventListener("touchstart", function (e) {
        startPointX = e.changedTouches[0].pageX;
      });

      box.addEventListener("touchmove", function (e) {
        stopPointX = e.changedTouches[0].pageX;
      });

      const that = this;
      box.addEventListener("touchend", function (e) {
        if (stopPointX === 0 || startPointX - stopPointX === 0) {
          resetPoint();
          return;
        }

        if (startPointX - stopPointX > 0) {
          resetPoint();
          that.$refs[name].next();
          return;
        }

        if (startPointX - stopPointX < 0) {
          resetPoint();
          that.$refs[name].prev();
          return;
        }
      });
    },
    // 提取 HTML 中的所有图片
    extractImagesFromHTML() {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = this.information.Introduction;
      const images = tempDiv.querySelectorAll("img");
      return Array.from(images).map((img) => img.src);
    },

    // 设置图片预览 - 使用 Element UI 的预览方式
    setupImagePreview() {
      this.$nextTick(() => {
        const images = this.extractImagesFromHTML();
        if (images.length === 0) return;

        // 为 PC 端和移动端分别设置
        ["introContentPC", "introContentMobile"].forEach((refName) => {
          const container = this.$refs[refName];
          if (container) {
            const imgs = container.querySelectorAll("img");
            imgs.forEach((img, index) => {
              img.style.cursor = "pointer";

              // 添加点击事件
              img.addEventListener("click", () => {
                this.previewImages(index, images);
              });
            });
          }
        });
      });
    },

    // 使用 Element UI 的图片预览
    previewImages(currentIndex, images) {
      // 使用 Element UI 的图片预览组件
      this.$nextTick(() => {
        // 创建预览容器
        const previewWrapper = document.createElement("div");
        previewWrapper.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.9);
      z-index: 9999;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    `;

        // 创建图片容器
        const imgContainer = document.createElement("div");
        imgContainer.style.cssText = `
      position: relative;
      max-width: 90%;
      max-height: 90%;
    `;

        // 创建图片
        const img = document.createElement("img");
        img.src = images[currentIndex];
        img.style.cssText = `
      width: 100%;
      height: 100%;
      object-fit: contain;
      transition: transform 0.3s ease;
      transform-origin: center center;
    `;

        // 缩放控制变量
        let scale = 1;
        const minScale = 0.5;
        const maxScale = 5;
        const zoomStep = 0.2;

        // 更新图片缩放
        const updateScale = () => {
          img.style.transform = `scale(${scale})`;
        };

        // 放大函数
        const zoomIn = () => {
          if (scale < maxScale) {
            scale += zoomStep;
            updateScale();
          }
        };

        // 缩小函数
        const zoomOut = () => {
          if (scale > minScale) {
            scale -= zoomStep;
            updateScale();
          }
        };

        // 重置缩放
        const resetZoom = () => {
          scale = 1;
          updateScale();
        };

        // 创建缩放控制按钮容器
        const zoomControls = document.createElement("div");
        zoomControls.style.cssText = `
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      background: rgba(0, 0, 0, 0.7);
      border-radius: 20px;
      padding: 8px 16px;
      display: flex;
      align-items: center;
      gap: 15px;
      z-index: 10001;
    `;

        // 缩小按钮
        const zoomOutBtn = document.createElement("button");
        zoomOutBtn.innerHTML = "-";
        zoomOutBtn.style.cssText = `
      background: rgba(255, 255, 255, 0.2);
      border: none;
      color: white;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      cursor: pointer;
      font-size: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
    `;
        zoomOutBtn.addEventListener("click", (e) => {
          e.stopPropagation();
          zoomOut();
        });

        // 当前缩放比例显示
        const scaleDisplay = document.createElement("span");
        scaleDisplay.style.cssText = `
      color: white;
      font-size: 14px;
      min-width: 45px;
      text-align: center;
    `;

        // 放大按钮
        const zoomInBtn = document.createElement("button");
        zoomInBtn.innerHTML = "+";
        zoomInBtn.style.cssText = `
      background: rgba(255, 255, 255, 0.2);
      border: none;
      color: white;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      cursor: pointer;
      font-size: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
    `;
        zoomInBtn.addEventListener("click", (e) => {
          e.stopPropagation();
          zoomIn();
        });

        // 重置按钮
        const resetBtn = document.createElement("button");
        resetBtn.innerHTML = "Reset";
        resetBtn.style.cssText = `
      background: rgba(255, 255, 255, 0.2);
      border: none;
      color: white;
      padding: 5px 10px;
      border-radius: 15px;
      cursor: pointer;
      font-size: 12px;
      margin-left: 10px;
    `;
        resetBtn.addEventListener("click", (e) => {
          e.stopPropagation();
          resetZoom();
        });

        // 更新缩放显示
        const updateScaleDisplay = () => {
          scaleDisplay.textContent = `${Math.round(scale * 100)}%`;
        };

        // 初始化显示
        updateScaleDisplay();

        // 将按钮添加到控制容器
        zoomControls.appendChild(zoomOutBtn);
        zoomControls.appendChild(scaleDisplay);
        zoomControls.appendChild(zoomInBtn);
        zoomControls.appendChild(resetBtn);

        // 创建导航按钮（如果有多张图片）
        let prevBtn, nextBtn, closeBtn;

        if (images.length > 1) {
          // 上一张按钮
          prevBtn = document.createElement("div");
          prevBtn.innerHTML = "‹";
          prevBtn.style.cssText = `
        position: absolute;
        left: -50px;
        top: 50%;
        transform: translateY(-50%);
        color: white;
        font-size: 40px;
        cursor: pointer;
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
      `;
          prevBtn.addEventListener("click", (e) => {
            e.stopPropagation();
            let newIndex = currentIndex - 1;
            if (newIndex < 0) newIndex = images.length - 1;
            img.src = images[newIndex];
            currentIndex = newIndex;
            // 切换到新图片时重置缩放
            resetZoom();
            updateScaleDisplay();
          });

          // 下一张按钮
          nextBtn = document.createElement("div");
          nextBtn.innerHTML = "›";
          nextBtn.style.cssText = `
        position: absolute;
        right: -50px;
        top: 50%;
        transform: translateY(-50%);
        color: white;
        font-size: 40px;
        cursor: pointer;
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
      `;
          nextBtn.addEventListener("click", (e) => {
            e.stopPropagation();
            let newIndex = currentIndex + 1;
            if (newIndex >= images.length) newIndex = 0;
            img.src = images[newIndex];
            currentIndex = newIndex;
            // 切换到新图片时重置缩放
            resetZoom();
            updateScaleDisplay();
          });
        }

        // 创建关闭按钮
        closeBtn = document.createElement("div");
        closeBtn.innerHTML = "×";
        closeBtn.style.cssText = `
      position: absolute;
      top: -40px;
      right: -5px;
      color: white;
      font-size: 30px;
      cursor: pointer;
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 50%;
    `;

        // 添加鼠标滚轮缩放功能
        imgContainer.addEventListener("wheel", (e) => {
          e.preventDefault();
          if (e.deltaY < 0) {
            // 向上滚动，放大
            zoomIn();
          } else {
            // 向下滚动，缩小
            zoomOut();
          }
          updateScaleDisplay();
        });

        // 添加双击切换缩放功能
        img.addEventListener("dblclick", (e) => {
          e.stopPropagation();
          if (scale === 1) {
            scale = 2;
          } else {
            scale = 1;
          }
          updateScale();
          updateScaleDisplay();
        });

        // 缩放时更新显示
        // const originalUpdateScale = updateScale;
        // updateScale = () => {
        //   originalUpdateScale();
        //   updateScaleDisplay();
        // };

        // 组装元素
        imgContainer.appendChild(img);
        if (images.length > 1) {
          imgContainer.appendChild(prevBtn);
          imgContainer.appendChild(nextBtn);
        }
        imgContainer.appendChild(closeBtn);
        previewWrapper.appendChild(imgContainer);
        previewWrapper.appendChild(zoomControls);
        document.body.appendChild(previewWrapper);

        // 添加键盘快捷键
        const handleKeyDown = (e) => {
          if (!document.body.contains(previewWrapper)) return;

          switch (e.key) {
            case "Escape":
              closePreview();
              break;
            case "+":
            case "=":
              if (e.ctrlKey || e.metaKey) {
                e.preventDefault();
                zoomIn();
              }
              break;
            case "-":
              if (e.ctrlKey || e.metaKey) {
                e.preventDefault();
                zoomOut();
              }
              break;
            case "0":
              if (e.ctrlKey || e.metaKey) {
                e.preventDefault();
                resetZoom();
              }
              break;
            case "ArrowLeft":
              if (images.length > 1) {
                e.preventDefault();
                let newIndex = currentIndex - 1;
                if (newIndex < 0) newIndex = images.length - 1;
                img.src = images[newIndex];
                currentIndex = newIndex;
                resetZoom();
              }
              break;
            case "ArrowRight":
              if (images.length > 1) {
                e.preventDefault();
                let newIndex = currentIndex + 1;
                if (newIndex >= images.length) newIndex = 0;
                img.src = images[newIndex];
                currentIndex = newIndex;
                resetZoom();
              }
              break;
          }
        };

        // 关闭预览
        const closePreview = () => {
          if (document.body.contains(previewWrapper)) {
            document.body.removeChild(previewWrapper);
          }
          document.removeEventListener("keydown", handleKeyDown);
        };

        // 点击遮罩层或关闭按钮关闭
        const handleClick = (e) => {
          if (e.target === previewWrapper || e.target === closeBtn) {
            closePreview();
          }
        };

        previewWrapper.addEventListener("click", handleClick);
        document.addEventListener("keydown", handleKeyDown);

        // 移动端优化
        if (this.offsetwidth <= 850) {
          // 调整移动端按钮大小
          if (prevBtn && nextBtn) {
            prevBtn.style.fontSize = "30px";
            prevBtn.style.width = "40px";
            prevBtn.style.height = "40px";
            prevBtn.style.left = "0";

            nextBtn.style.fontSize = "30px";
            nextBtn.style.width = "40px";
            nextBtn.style.height = "40px";
            nextBtn.style.right = "0";
          }

          zoomControls.style.padding = "5px 12px";
          zoomControls.style.bottom = "10px";

          closeBtn.style.top = "-35px";
          closeBtn.style.right = "0";
          closeBtn.style.fontSize = "25px";
          closeBtn.style.width = "35px";
          closeBtn.style.height = "35px";
        }
      });
    },
  },
};
</script>
<style>
/* 全局样式 - 放在你的全局CSS文件中 */
/* 增加预览容器尺寸 */
/* .el-image-viewer__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
} */

/* 设置初始放大比例 */
/* .el-image-viewer__img {
  transform: scale(1.2) !important;
  transition: transform 0.3s ease;
} */

/* 隐藏操作按钮（可选） */
/* .el-image-viewer__btn {
  display: none !important;
} */
</style>
<style scoped lang="scss">
::v-deep .el-carousel__indicator.is-active .el-carousel__button {
  background-color: #409eff !important;
}

.LearnBtn {
  width: 220px;
  color: #fff;
  background: #0869b5;
}
.LearnBtn:hover {
  width: 220px;
  color: #fff;
  background: #0c9b47;
}
.LearnBtn:focus {
  width: 220px;
  color: #fff;
  background: #0c9b47;
}
::v-deep .el-icon-arrow-right {
  font-weight: 600;
}
::v-deep .el-icon-arrow-left {
  font-weight: 600;
}
::v-deep .el-carousel__arrow--left {
  left: 2px;
}
::v-deep .el-carousel__arrow--right {
  right: 2px;
}
//箭头
::v-deep .el-carousel__arrow--left,
::v-deep .el-carousel__arrow--right {
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  height: 24px;
  width: 24px;
  cursor: pointer;
  transition: 0.3s;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0);
  color: #0869b5;
  position: absolute;
  top: 50%;
  z-index: 10;
  transform: translateY(-50%);
  text-align: center;
  font-size: 20px;
  // display: none;
  // top: 70px;
  // right: -13px;
  // font-size: 15px;
  // color: #02E9FF;
}

::v-deep .el-carousel__button {
  left: auto;
  right: 10px;
  bottom: 10px;
  text-align: right;
  // top: 4.5%;
  // right: 22%;
  display: block;
  opacity: 0.48;
  width: 8px;
  height: 8px;
  background-color: #666;
  border: none;
  outline: 0;
  padding: 0;
  margin: 5px;
  border-radius: 50%;
  cursor: pointer;
  transition: 0.3s;
}
.header-navbar {
  padding: 20px 40px;
  background-color: white;
  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */
}
.top-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logo-container {
  flex-shrink: 0;
}
.logo {
  display: flex;
  align-items: center;
  gap: 8px;
}
.logo-icon {
  font-size: 24px;
}
.logo-text {
  font-size: 18px;
  font-weight: 600;
}
.nav-items {
  display: flex;
  gap: 30px;
}
.nav-item {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
  padding: 5px 0;
  position: relative;
  border-bottom: 2px solid transparent;
}
/* 悬停和激活状态统一效果 */
.nav-item:hover,
.nav-item.active {
  color: #0869b5 !important;
  /* border-bottom-color: #0c80da !important; */
}
/* 下划线动画效果 */
/* .nav-item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 1px;
  background-color: #1890ff;
  transition: width 0.3s;
} */
.nav-item:hover::after,
.nav-item.active::after {
  width: 100%; /* 悬停和激活时下划线宽度一致 */
}
.email-info {
  margin-top: 30px;
}
.email-content {
  font-size: 12px;
  color: #666;
  text-align: right;
  line-height: 1.6;
}
@media (max-width: 768px) {
  .top-nav {
    flex-direction: column;
    gap: 20px;
  }

  .nav-items {
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;
  }

  .email-content {
    text-align: center;
  }
}
</style>

<style scoped>
#playbtn:hover,
.playbtn {
  opacity: 1;
}
#playbtn {
  opacity: 0.1;
}
.slide-content {
  /* border-top: 2px solid #eee; */
  border-bottom: 2px solid #eee;
}
.slide-content:nth-last-child(1) {
  border-right: 2px solid #eee;
}
.image-row {
  /* 这里可以添加额外的行样式，但通常 <el-row> 会有默认的样式 */
  margin: 0; /* 去除行容器的外边距 */
}

.image-col {
  /* 由于我们使用了 :gutter="0"，这里通常不需要额外的间距样式 */
  padding: 0; /* 去除列容器的内边距（虽然 <el-col> 默认可能没有内边距） */
}

.image-container {
  display: flex;
  flex-wrap: wrap; /* 允许换行 */
  gap: 0; /* 设置图片之间的间距为0 */
  margin: 0; /* 去除容器自身的外边距 */
  padding: 0; /* 去除容器自身的内边距 */
}

.image-container > el-image {
  flex: 0 0 calc(50% - 0px); /* 每列占据50%的宽度，0px是调整间距的，这里不需要额外间距 */
  box-sizing: border-box; /* 确保内边距和边框包含在宽度内 */
}

.vc_custom_1627269981297copy {
  /* margin-bottom: -40px !important; */
  padding-top: 50px !important;
  padding-bottom: 40px !important;
  background-color: #84b903 !important;
}
/* .vc_custom_1626061515335 {
  margin-bottom: -40px !important;
  padding-top: 50px !important;
  padding-bottom: 40px !important;
  background-color: #84b903 !important;
} */
/* .special-link {
  text-decoration: underline;
}
a:link {
  color: blue;
} */
/* 已访问的链接 */
/* a:visited {
  color: purple;
} */

/* 鼠标悬浮在链接上 */
/* a:hover {
  color: red;
} */

/* .mt_20 {
  margin-top: 20px;
}
.mt_10 {
  margin-top: 10px;
}
.text_bold {
  font-weight: 700;
}
.pcss {
  font-family: Poppins;
  font-weight: 300;
  font-style: normal;
  font-size: 15px;
}
.titlecss {
  font-family: Poppins;
  font-style: normal;
} */

/* 图片容器相对定位 */
.banner-text {
  position: absolute;
  top: 50%;
  left: 10%;
  transform: translateY(-50%);
  color: white;
  text-align: left;
  z-index: 10;
}

.text-line-1 {
  font-size: clamp(24px, 3vw, 48px);
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 8px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.text-line-2 {
  font-size: clamp(18px, 2.2vw, 36px);
  font-weight: 600;
  line-height: 1.2;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .banner-text {
    left: 8%;
  }
}

@media (max-width: 992px) {
  .banner-text {
    left: 6%;
  }
}

@media (max-width: 768px) {
  .banner-text {
    left: 5%;
  }

  .text-line-1 {
    font-size: clamp(20px, 4vw, 32px);
  }

  .text-line-2 {
    font-size: clamp(16px, 3vw, 24px);
  }
}
</style>
<style scoped>
/* 添加到现有样式的末尾 */

/* 图片预览中的按钮悬停效果 */
button:hover {
  background: rgba(255, 255, 255, 0.3) !important;
}

/* 移动端优化 */
@media (max-width: 768px) {
  .zoom-controls {
    bottom: 10px !important;
    padding: 5px 12px !important;
  }

  .zoom-btn {
    width: 25px !important;
    height: 25px !important;
    font-size: 16px !important;
  }

  .zoom-percent {
    font-size: 12px !important;
  }

  .reset-btn {
    font-size: 11px !important;
    padding: 4px 8px !important;
  }
}
</style>
<style scoped>
.header-navbar {
  padding: 20px 40px;
  background-color: white;
  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */
}
.top-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logo-container {
  flex-shrink: 0;
}
.logo {
  display: flex;
  align-items: center;
  gap: 8px;
}
.logo-icon {
  font-size: 24px;
}
.logo-text {
  font-size: 18px;
  font-weight: 600;
}
.nav-items {
  display: flex;
  gap: 30px;
}
.nav-item {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
  padding: 5px 0;
  position: relative;
  border-bottom: 2px solid transparent;
}
/* 悬停和激活状态统一效果 */
.nav-item:hover,
.nav-item.active {
  color: #0869b5 !important;
  /* border-bottom-color: #0c80da !important; */
}
/* 下划线动画效果 */
/* .nav-item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 1px;
  background-color: #1890ff;
  transition: width 0.3s;
} */
.nav-item:hover::after,
.nav-item.active::after {
  width: 100%; /* 悬停和激活时下划线宽度一致 */
}
.email-info {
  margin-top: 30px;
}
.email-content {
  font-size: 12px;
  color: #666;
  text-align: right;
  line-height: 1.6;
}
@media (max-width: 768px) {
  .top-nav {
    flex-direction: column;
    gap: 20px;
  }

  .nav-items {
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;
  }

  .email-content {
    text-align: center;
  }
}
</style>
<style scoped>
/* 移动端底部导航栏样式 */
.mobile-footer-navbar {
  background-color: white;
  padding: 20px;
  /* box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); */
}
.vertical-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.logo-section,
.nav-section,
.contact-section {
  text-align: left; /* 确保左对齐 */
}
.logo-container {
  margin-bottom: 10px;
}
.nav-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.nav-item {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
  padding: 5px 0;
  position: relative;
  border-bottom: 2px solid transparent;
}
/* 悬停和激活状态统一效果 */
.nav-item:hover,
.nav-item.active {
  color: #0869b5 !important;
  /* border-bottom-color: #0c80da !important; */
}
.contact-section {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.email-contentmobile {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
}
/* 响应式调整 */
@media (max-width: 480px) {
  .vertical-container {
    gap: 15px;
  }

  .nav-section {
    gap: 2px;
  }

  .nav-item {
    font-size: 14px;
    font-weight: bold;
  }

  .email-contentmobile {
    font-size: 12px;
  }
}
.fonthover:hover {
  color: #0869b5;
}
</style>
